<template>
  <div class="contents register userInfo">
    <section class="box one">
      <h2>리스닝 학습 관리</h2>

      <div class="inputBox listening">
        <div class="flex">
          <p>
            카테고리
            <span>*</span>
          </p>
          <el-select v-model="category">
            <el-option
              v-for="(item, i) in categories"
              :key="i"
              :value="item"
              :label="getCategoryDisplayName(item)"
            >
            </el-option>
          </el-select>
        </div>

        <div class="flex double">
          <p>
            한국어 문장
            <span>*</span>
          </p>
          <div class="flex desc listening">
            <textarea
              class="full"
              :maxlength="50"
              v-model="sentence"
              placeholder="앱에서 TTS로 재생할 한국어 문장을 입력해 주세요."
            />
            <p class="note-length">{{ (sentence || "").length }} / 50</p>
          </div>
        </div>

        <div class="flex double">
          <p>
            해설
            <span>*</span>
          </p>
          <div class="flex desc listening">
            <textarea
              class="full"
              v-model="hintSentenceEn"
              placeholder="영어 해설을 입력해 주세요."
              :maxlength="500"
            />
            <p class="note-length">{{ (hintSentenceEn || "").length }} / 500</p>
            <textarea
              class="full"
              v-model="hintSentenceJp"
              placeholder="일본어 해설을 입력해 주세요."
              :maxlength="500"
            />
            <p class="note-length">{{ (hintSentenceJp || "").length }} / 500</p>
          </div>
        </div>

        <div class="flex double">
          <p>정답 처리 문장</p>
          <div class="flex desc listening">
            <p class="guide">
              실제 문장은 자동으로 정답 배열에 포함됩니다. 발음이 비슷하면 정답
              처리할 문장을 추가로 입력해 주세요.
            </p>

            <div
              class="answerRow"
              v-for="(answer, index) in answers"
              :key="index"
            >
              <input
                class="full"
                type="text"
                v-model="answers[index]"
                :placeholder="`추가 정답 문장 ${index + 1}`"
              />
              <button
                class="line removeButton"
                type="button"
                @click="removeAnswer(index)"
              >
                삭제
              </button>
            </div>

            <button class="line addButton" type="button" @click="addAnswer">
              정답 문장 추가
            </button>
          </div>
        </div>
      </div>

      <div class="buttonWrap">
        <button class="basic" @click="submit">
          {{ editMode == true ? "수정" : "등록" }}
        </button>
        <button v-if="editMode" class="line" @click="handleDelete">삭제</button>
      </div>
    </section>

    <div class="buttonWrap">
      <router-link to="/admin/listening/manage">
        <span class="material-icons-round"> keyboard_backspace </span
        >목록</router-link
      >
    </div>
  </div>
</template>

<script>
import category from "@/config/listeningCategory.json";
import { getListeningCategoryDisplayName } from "@/utils/listeningCategoryDisplay";
import {
  createListening,
  fetchListening,
  updateListening,
  removeListening,
} from "@/api/admin";

export default {
  data() {
    return {
      editMode: false,
      listeningId: "",
      category: "",
      sentence: "",
      hintSentenceEn: "",
      hintSentenceJp: "",
      answers: [""],
      categories: [],
    };
  },

  created() {
    this.$store.dispatch("SET_NAVBAR", "5");
  },

  mounted() {
    this.categories = category.categories;
    if (this.$route.query.id) {
      this.editMode = true;
      this.listeningId = this.$route.query.id;
      this.getListening();
    } else if (this.$route.query.category) {
      this.category = this.$route.query.category;
    }
  },

  methods: {
    getCategoryDisplayName(name) {
      return getListeningCategoryDisplayName(name);
    },
    normalizeAnswers(sentence, answers = []) {
      const normalizedSentence = (sentence || "").trim();
      const merged = [normalizedSentence, ...answers]
        .map((item) => (item || "").trim())
        .filter(Boolean);

      return [...new Set(merged)];
    },

    addAnswer() {
      this.answers.push("");
    },

    removeAnswer(index) {
      this.answers.splice(index, 1);
      if (this.answers.length === 0) {
        this.answers.push("");
      }
    },

    getListening() {
      fetchListening(this.listeningId).then((res) => {
        const item = res.data.data || {};
        console.log("detail", item);

        if (res.data.status == 200) {
          const sentence = (item.sentence || "").trim();
          const savedAnswers = Array.isArray(item.answers) ? item.answers : [];

          this.category = item.category || "";
          this.sentence = sentence;
          this.hintSentenceEn = item.hintSentenceEn || "";
          this.hintSentenceJp = item.hintSentenceJp || "";
          this.answers = savedAnswers
            .map((answer) => (answer || "").trim())
            .filter((answer) => answer && answer !== sentence);

          if (this.answers.length === 0) {
            this.answers = [""];
          }
        } else {
          let message = res.data.message;
          alert(message);
        }
      });
    },

    handleDelete() {
      let result = confirm("삭제 하시겠습니까?");
      if (!result) {
        return;
      }

      removeListening(this.listeningId).then((res) => {
        if (res.data.status == 200) {
          alert("리스닝 문장이 삭제 되었습니다.");
          this.$router.replace("/admin/listening/manage");
        }
      });
    },

    submit() {
      const normalizedSentence = this.sentence.trim();
      const normalizedHintSentenceEn = this.hintSentenceEn.trim();
      const normalizedHintSentenceJp = this.hintSentenceJp.trim();
      const answers = this.normalizeAnswers(normalizedSentence, this.answers);

      if (this.category == "") {
        return alert("카테고리를 선택해 주세요.");
      } else if (!normalizedSentence) {
        return alert("한국어 문장을 입력해 주세요.");
      } else if (!normalizedHintSentenceEn) {
        return alert("영어 해설을 입력해 주세요.");
      } else if (!normalizedHintSentenceJp) {
        return alert("일본어 해설을 입력해 주세요.");
      }

      let data = {
        listeningId: this.listeningId,
        category: this.category,
        sentence: normalizedSentence,
        hintSentenceEn: normalizedHintSentenceEn,
        hintSentenceJp: normalizedHintSentenceJp,
        answers: answers,
      };

      console.log(">>> SUBMIT DATA", data);

      if (this.editMode) {
        updateListening(data).then((res) => {
          if (res.data.status == 200) {
            alert("리스닝 문장 정보가 반영 되었습니다.");
            this.$router.push("/admin/listening/manage");
          } else {
            let message = res.data.message;
            alert(message);
          }
        });
      } else {
        createListening(data).then((res) => {
          if (res.data.status == 200) {
            alert("리스닝 문장 등록이 완료 되었습니다.");
            this.$router.push("/admin/listening/manage");
          } else {
            let message = res.data.message;
            alert(message);
          }
        });
      }
    },
  },
};
</script>

<style scoped lang="scss">
textarea {
  width: 100% !important;
}

.guide {
  width: 100% !important;
  margin-bottom: 8px;
  color: #6b7280;
  font-size: 13px;
  line-height: 1.5;
}

.answerRow {
  display: flex;
  width: 100%;
  gap: 8px;
}

.answerRow + .answerRow {
  margin-top: 8px;
}

.addButton,
.removeButton {
  min-width: 92px;
}

.addButton {
  margin-left: 0 !important;
}
</style>
